import { acceptInsuranceHandler } from './acceptInsuranceHandler';
import { acceptOfferHandler } from './acceptOfferHandler';
import { complementaryConsolidationHandler } from './complementaryConsolidationHandler';
import { decryptHandlers } from './decryptHandler';
import { draftConsentHandler } from './draftConsentHandler';
import { encryptHandlers } from './encryptHandler';
import { enrichAccountInformationHandlers } from './enrichAccountInformationHandlers';
import { getConsentsHandlers } from './getConsentsHandler';
import { getDebtsHandler } from './getDebtsHandler';
import { getDeclineReasonHandlers } from './getDeclineReasonHandlers';
import { getFinalOffersHandlers } from './getFinalOfferHandler';
import { getKnowYourCustomerHandlers } from './getKycHandler';
import { getOffersHandlers } from './getOffersHandlers';
import { getOngoinApplicationHandlers } from './getOngoingApplicationHandlers';
import { getSelectedConsolidationsHandlers } from './getSelectedConsolidationsHandler';
import { getSigningStatusHandler } from './getSigningStatusHandler';
import { getStateHandlers } from './getStateHandlers';
import { getSummaryHandler } from './getSummaryHandler';
import { oauthHandlers } from './oauthHandlers';
import { patchApplicationHandlers } from './patchApplicationHandlers';
import { saveKnowYourCustomerAnswersHandlers } from './saveKycAnswersHandlers';
import { signingLinkHandler } from './signingLinkHandler';
import { submitCoApplicantHandlers } from './submitCoApplicantHandler';
import { submitHandlers } from './submitHandlers';
import { validateGovernmentIdHandlers } from './validateGovernmentIdHandlers';
import { validateKidHandlers } from './validateKidHandlers';

export const handlers = [
    ...oauthHandlers,
    ...encryptHandlers,
    ...decryptHandlers,
    ...getKnowYourCustomerHandlers,
    ...submitHandlers,
    ...getStateHandlers,
    ...getOffersHandlers,
    // enrichAccountInformationHandlers must stay registered before patchApplicationHandlers: MSW resolves
    // PATCH .../application/:arn/<segment> requests by first match, and patchApplicationHandlers' trailing
    // :languageCode segment is broad enough to otherwise shadow this more specific path.
    ...enrichAccountInformationHandlers,
    ...patchApplicationHandlers,
    ...acceptInsuranceHandler,
    ...acceptOfferHandler,
    ...saveKnowYourCustomerAnswersHandlers,
    ...getFinalOffersHandlers,
    ...signingLinkHandler,
    ...validateGovernmentIdHandlers,
    ...getOngoinApplicationHandlers,
    ...getSigningStatusHandler,
    ...getSummaryHandler,
    ...submitCoApplicantHandlers,
    ...getDebtsHandler,
    ...getSelectedConsolidationsHandlers,
    ...complementaryConsolidationHandler,
    ...validateKidHandlers,
    ...draftConsentHandler,
    ...getConsentsHandlers,
    ...getDeclineReasonHandlers,
];
